import React from 'react';

import FullPageTerminalStateLayout from 'src/components/creditApplication/FullPageTerminalStateLayout';
import { LoginPageUrl } from 'src/constants/urls';
import { clearAuthState } from 'src/state/auth/auth';

const AccountAlreadyExistsPage = () => {
  const onLogin = React.useCallback(() => {
    clearAuthState();
  }, []);

  return (
    <FullPageTerminalStateLayout
      title='Looks like you already have an account'
      subtitle='An existing Robinhood account is already linked to that information. Log in to fast-track your Gold Card application.'
      icon='Lightbulb24'
      buttonLabel='Log in'
      buttonType='anchor'
      buttonHref={LoginPageUrl}
      showGetHelpButton
      onButtonPress={onLogin}
    />
  );
};

export default AccountAlreadyExistsPage;
